import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/** Heart toggle for saving something to a favourites list; filled when saved. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-favourite-heart',
  imports: [MatIcon],
  template: `
    <button type="button" class="heart" [class.saved]="saved()" [class.small]="size() === 'small'"
      [attr.aria-pressed]="saved()" [attr.aria-label]="label()" [title]="title()"
      (click)="$event.preventDefault(); $event.stopPropagation(); toggled.emit()">
      <mat-icon>{{saved() ? 'favorite' : 'favorite_border'}}</mat-icon>
    </button>
  `,
  styles: [`
    :host { display: inline-flex; }
    .heart { border: none; background: transparent; cursor: pointer; padding: 4px; border-radius: 50%; color: #666; line-height: 0; }
    .heart:hover { background: rgba(103, 58, 183, 0.1); color: #673ab7; }
    .heart.saved { color: #e53935; }
    .heart.small { padding: 2px; }
    .heart.small mat-icon { font-size: 18px; width: 18px; height: 18px; }
  `]
})
export class FavouriteHeartComponent {
  saved = input(false);
  /** What is being saved, e.g. the artist's name (for accessibility). */
  name = input('');
  /** The list's name, e.g. 'Favourite Artists'. */
  list = input('Favourites');
  size = input<'normal' | 'small'>('normal');
  toggled = output<void>();

  label = computed(() => `${this.saved() ? 'Remove' : 'Add'} ${this.name() || 'this'} ${this.saved() ? 'from' : 'to'} ${this.list()}`);
  title = computed(() => `${this.saved() ? 'Remove from' : 'Add to'} ${this.list()}`);
}
